import React, { useRef, useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import LandingPage from "./LandingPage";
import CreateEvent from "./CreateEvent";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsService from "./TermsService";
import "./App.css";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const authChecked = useRef(false);

  useEffect(() => {
    if (authChecked.current) return;
    authChecked.current = true;

    const checkAuthStatus = async () => {
      try {
        const response = await fetch("https://api.aicalendarassist.com/authenticated", {
          method: "GET",
          headers: { 'Content-Type': 'application/json' },
          credentials: "include",
        });
        const data = await response.json();
        console.log("DATA authenticated:", data);
        setIsAuthenticated(data.is_authenticated || false);
        console.log("Authenticated:", data.is_authenticated || false);
        if (data.is_authenticated && data.email) {
          setUserEmail(data.email);
        }
      } catch (error) {
        console.error("Error checking auth status:", error);
        setIsAuthenticated(false);
      }
    };

    checkAuthStatus();
  }, []);

  const handleLogin = async () => {
    try {
      const response = await fetch("https://api.aicalendarassist.com/auth"); //https://ai-calendar-assistant.onrender.com
      const data = await response.json();
      if (data.auth_url){
        window.location.href = data.auth_url;
      } 
    } catch (error) {
      console.error("Error fetching auth URL:", error);
    }
  };

  const handleLogout = async () => {
    try {
      const response = await fetch(
        `https://api.aicalendarassist.com/logout?user_email=${encodeURIComponent(userEmail)}`,
        { method: "GET", credentials: "include" }
      );
      const data = await response.json();
      console.log("Logout response:", data);
      if (response.ok) {
        setIsAuthenticated(false);
        setUserEmail('');
        window.location.href = "https://www.aicalendarassist.com"; // http://localhost:3000 | https://ai-calendar-assistant.vercel.app
      }
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  return (
    <Router>
      <div className="min-h-screen">
        {/* Navigation Bar - Single Line Layout */}
        <nav className="navbar">
          <div className="navbar-content">
            <div className="navbar-left">
              <Link to="/" className="navbar-title">
                AI Google Calendar Assistant
              </Link>
              <div className="nav-links">
                <Link to="/" className="nav-link">
                  Home
                </Link>
                <Link to="/create-event" className="nav-link">
                  Create Event
                </Link>
              </div>
            </div>
            <div className="navbar-right">
              {isAuthenticated ? (
                <>
                  <span className="authenticated-text">Logged in as: {userEmail}</span>
                  <button onClick={handleLogout} className="login-button">
                    Logout
                  </button>
                </>
              ) : (
                <button onClick={handleLogin} className="login-button">
                  Login with Google
                </button>
              )}
            </div>
          </div>
        </nav>

        {/* Main Content */}
        <Routes>
          <Route path="/" element={<LandingPage isAuthenticated={isAuthenticated} />} />
          <Route
            path="/create-event"
            element={
              <CreateEvent
                isAuthenticated={isAuthenticated}
                userEmail={userEmail}
              />
            }
          />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsService />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
